import { Bancolle } from '@/modules/Collection';
import Repository from './client/TbsJsonAxiosClient';

const resource = '/bancolle';

export const useBancolleRepository = () => {
  /**
   * 番コレホームリストJSONを取得する
   */
  const get = async () => {
    const { data } = await Repository.get<{ bancolles: Bancolle[] }>(`${resource}/home_existence.json`).catch((e) => {
      throw e;
    });

    return data;
  };

  return {
    get,
  };
};

export type BancolleRepository = ReturnType<typeof useBancolleRepository>;
